module.exports = __webpack_public_path__ + "e54649187f2e411aa123d022645f01c1.png";